import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import './i18n/config'; // Initialize i18n
import useLanguageStore from './store/languageStore';
import i18n from './i18n/config';

// Componente wrapper per sincronizzare i18n con lo store all'avvio
const I18nSync = ({ children }) => {
    useEffect(() => {
        // NON impostare la lingua all'avvio - sarà gestita da initializeLanguage quando eventData è disponibile
        // Solo sincronizza i cambiamenti di lingua nello store con i18n
        const unsubscribe = useLanguageStore.subscribe(() => {
            const currentLang = useLanguageStore.getState().currentLanguage;
            if (i18n.language !== currentLang) {
                i18n.changeLanguage(currentLang);
            }
        });

        return unsubscribe;
    }, []);

    return <>{children}</>;
};

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <I18nSync>
                <App/>
            </I18nSync>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
